import app from 'flarum/forum/app';

app.initializers.add('nodeloc/flarum-telegram-notification', () => {
});
